import cecLogo from '../../images/cec-logo.svg';
import { EANR_PRIVACY_NOTICE, EANR_TERMS_AND_CONDITIONS } from '../../constants';

const Footer = () => {
  return (
    <footer id="eanr-footer" className="bg-light border-top mt-auto">
      <div className="container py-3">
        <a href="#" className="logo">
          <img src={cecLogo} alt="The Careers & Enterprise Company" title="The Careers & Enterprise Company" />
        </a>
        <div className="buttons">
          <p className="mb-0">
            © The Careers and Enterprise Company {(new Date().getFullYear())}. All rights reserved. <a
              href={EANR_PRIVACY_NOTICE}
              className="link-teal-to-gray-color-blind"
              target="_blank"
              rel="noopener noreferrer">
              CEC privacy notice
            </a> | <a
              href={EANR_TERMS_AND_CONDITIONS}
              className="link-teal-to-gray-color-blind"
              target="_blank"
              rel="noopener noreferrer">
              Terms and Conditions
            </a>.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
